// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3OYKK","subheader":"ReorderModal_subheader__2mAxs","listWrap":"ReorderModal_listWrap__ot9uQ"};